import DomainCommon from './common';

const InstitutionService = {
    add: (institution) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/institution`,
                jsonBody: institution,
                resolve, reject
            });
        });
    },
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/institution`,
                resolve, reject
            });
        });
    },
    findById: (institutionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/institution/${institutionId}`,
                resolve, reject
            });
        });
    },
};

export default InstitutionService;



// WEBPACK FOOTER //
// ./src/service/institution.js